import { useState, useEffect } from "react";
import axios from "axios";
import envConfig from "../../../../bin/env.config";
import { useSelector } from "react-redux";

export default function useMergeProductGroups() {
  const token = useSelector((state) => state.session.token);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [mergeSuggestions, setMergeSuggestions] = useState({product_id:0,product_matching_group_id:0,suggested_group_id:0});
  const [groupADetails, setGroupADetails] = useState(null);
  const [groupBDetails, setGroupBDetails] = useState(null);
  const [loadingGroups, setLoadingGroups] = useState(false);

  useEffect(() => {
    fetchMergeSuggestions();
  }, []);

  
  const fetchMergeSuggestions = async () => {
    setIsLoading(true);
    try {
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/product-matching-group/merge-suggestion`;
      const result = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: JSON.stringify(token),
          },
        }
      );
      setMergeSuggestions(result.data.data || {product_id:0,product_matching_group_id:0,suggested_group_id:0});
      result.data.data&&fetchGroupDetails(result.data.data);
    } catch (error) {
      console.error("Error fetching merge suggestions:", error);
      setMergeSuggestions({product_id:0,product_matching_group_id:0,suggested_group_id:0});
    } finally {
      setIsLoading(false);
    }
  };

  const fetchGroupDetails = async (suggestion) => {
    setLoadingGroups(true);
    try {
      const [groupAResult, groupBResult] = await Promise.all([
        axios.get(
          `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/group/${suggestion.product_matching_group_id}`,
          {
            headers: {
              Authorization: JSON.stringify(token),
            },
          }
        ),
        axios.get(
          `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/group/${suggestion.suggested_group_id}`,
          {
            headers: {
              Authorization: JSON.stringify(token),
            },
          }
        ),
      ]);

      setGroupADetails({
        original: groupAResult.data.data.original,
        matches: groupAResult.data.data.matches || [],
      });
      setGroupBDetails({
        original: groupBResult.data.data.original,
        matches: groupBResult.data.data.matches || [],
      });
    } catch (error) {
      console.error("Error fetching group details:", error);
    } finally {
      setLoadingGroups(false);
    }
  };

  const handleMerge = async () => {
    
    const suggestion = mergeSuggestions;
    setIsActionLoading(true);
    try {
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/product-matching-group/merge/accept-suggestion`;
      await axios.post(
        url,
        {
          product_id: suggestion.product_id,
          product_matching_group_id: suggestion.product_matching_group_id,
          suggested_group_id: suggestion.suggested_group_id,
        },
        {
          headers: {
            Authorization: JSON.stringify(token),
          },
        }
      );
      
      // After successful merge, move to next suggestion
      fetchMergeSuggestions();
    } catch (error) {
      console.error("Error merging groups:", error);
      alert("Failed to merge groups. Please try again.");
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleReject = async () => {
    const suggestion = mergeSuggestions;
    setIsActionLoading(true);
    try {
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/product-matching-group/merge/reject-suggestion`;
      await axios.post(
        url,
        {
          product_id: suggestion.product_id,
          product_matching_group_id: suggestion.product_matching_group_id,
          suggested_group_id: suggestion.suggested_group_id,
        },
        {
          headers: {
            Authorization: JSON.stringify(token),
          },
        }
      );
      
      // Move to next suggestion
      fetchMergeSuggestions();
    } catch (error) {
      console.error("Error rejecting merge:", error);
      alert("Failed to reject merge suggestion. Please try again.");
    } finally {
      setIsActionLoading(false);
    }
  };

  return {
    isLoading,
    isActionLoading,
    mergeSuggestions,
    groupADetails,
    groupBDetails,
    loadingGroups,
    handleMerge,
    handleReject,
    fetchMergeSuggestions,
  };
}
